import React from 'react'
import PropTypes from 'prop-types'
// import colors from '../../utils/colors'
import styles from './checkbox.module.css'

const Checkbox = ({
  id,
  label,
  className,
  checked = undefined,
  defaultChecked,
  itemsCentered,
  rounded,
  indeterminate,
  ...rest
}) => {
  const componentType = checked === undefined ? 'uncontrolled' : 'controlled'

  // Note
  // Componentnya saya ubah jadi uncontrolled, kalau mau jadi controlled
  // setCheckednya ga bisa disini, harus di parent component
  // yang ngatur state checked

  // const [checked, setChecked] = React.useState(defaultChecked ? true : false)
  // const handleChange = (e) => {
  //   console.log(e.target)
  //   e.preventDefault()
  //   e.stopPropagation()

  //   setChecked(e.target.checked)
  // }

  const roundedStyle = {
    borderRadius: rounded ? "5px" : "0",
  };

  return (
    <label
      className={`flex ${className} ${styles.checkbox} ${
        itemsCentered ? "items-center" : ""
      }`}
    >
      <div className="bg-white">
        {
          componentType === 'controlled' ? (
            <input
              type="checkbox"
              id={id}
              className="hidden"
              checked={checked}
              indeterminate={indeterminate?.toString()}
              {...rest}
            />
          ) : (
            <input
              type="checkbox"
              id={id}
              className="hidden"
              defaultChecked={defaultChecked}
              indeterminate={indeterminate?.toString()}
              {...rest}
            />
          )
        }
        <div
          style={roundedStyle}
          className={`${
            label ? "mr-2" : ""
          } border flex justify-center items-center ${styles.outer}`}
        >
          <div style={roundedStyle} className={styles.inner}></div>
        </div>
      </div>
      <div className="cursor-pointer text-sm text-gray-444" htmlFor={id}>
        {label}
      </div>
    </label>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  onChange: PropTypes.func,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  itemsCentered: PropTypes.bool,
  rounded: PropTypes.bool,
}

Checkbox.defaultProps = {
  id: '',
  label: '',
  onChange: () => {},
  className: '',
  defaultChecked: false,
  itemsCentered: false,
  rounded: false,
}

export { Checkbox }
